import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';
import { BookForSalesDetailDTO, DashboardDTO } from '../models';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends __BaseService {

  static readonly dashboard = '/Dashboard';

  static dashboardPath(idEvent: number) {
    return DashboardService.dashboard + '/' + idEvent;
  }

  static rolePath() {
    return DashboardService.dashboard + '/Role';
  }

  static bookForSalePath(idEvent: number, sapCode: string) {
    return DashboardService.dashboard + '/' + idEvent + "/BookForSale/" + sapCode;
  }

  static exportPath(idEvent: number) {
    return DashboardService.dashboard + '/export/' + idEvent;
  }

  static exportBookForSalePath(idEvent: number) {
    return DashboardService.dashboard + '/export/bfs/' + idEvent;
  }

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  getDashboardParams(params: any) {
    let __params = this.newParams();
    if (params) {
      if (params.Search) __params = __params.set('Search', params.Search.toString());
      if (params.OrderBy) __params = __params.set('OrderBy', params.OrderBy.toString());
      if (params.isDesc) __params = __params.set('isDesc', params.isDesc.toString());
      if (params.Skip) __params = __params.set('Skip', params.Skip.toString());
      if (params.Limit) __params = __params.set('Limit', params.Limit.toString());
      if (params.Status !== undefined && params.Status !== null && !Number.isNaN(params.Status)) __params = __params.set('Status', params.Status.toString());
      if (params.AppointmentStatus !== undefined && params.AppointmentStatus !== null && !Number.isNaN(params.AppointmentStatus)) __params = __params.set('AppointmentStatus', params.AppointmentStatus.toString());
      if (params.AllocationCode !== undefined) __params = __params.set('AllocationCode', params.AllocationCode);
      if (params.SalesRoomId !== undefined && params.SalesRoomId !== null && !Number.isNaN(params.SalesRoomId)) __params = __params.set('SalesRoomId', params.SalesRoomId.toString());
      if (typeof params.IsBookedForSales === 'boolean') __params = __params.set('IsBookedForSales', params.IsBookedForSales.toString());
    }
    return __params;
  }

  /**
   * * GET DASHBOARD
   * @param idEvent
   * @param params
   * @returns Get a list of products for Dashboard
   */
  getDashboardResponse(idEvent: number, params: any): __Observable<__StrictHttpResponse<DashboardDTO>> {
    let __params = this.getDashboardParams(params);
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + DashboardService.dashboardPath(idEvent),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<DashboardDTO>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DashboardDTO>;
      })
    );
  }
  getDashboard(idEvent: number, params?: any): __Observable<any> {
    return this.getDashboardResponse(idEvent, params).pipe(
      __map(_r => _r.body as DashboardDTO)
    );
  }

  /**
 * * GET BOOK FOR SALES
 * @param idEvent
 * @param sapCode
 * @returns
 */
  getBookForSaleResponse(idEvent: number, sapCode: string): __Observable<__StrictHttpResponse<[BookForSalesDetailDTO]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + DashboardService.bookForSalePath(idEvent, sapCode),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<[BookForSalesDetailDTO]>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<[BookForSalesDetailDTO]>;
      })
    );
  }
  getBookForSale(idEvent: number, sapCode: string): __Observable<any> {
    return this.getBookForSaleResponse(idEvent, sapCode).pipe(
      __map(_r => _r.body as [BookForSalesDetailDTO])
    );
  }

  /**
 * EXPORT DASHBOARD
 * @param idEvent
 * @returns blob file
 */
  getExportResponse(idEvent: number): __Observable<__StrictHttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (idEvent != null) __params = __params.set('idEvent', idEvent.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + DashboardService.exportPath(idEvent),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }
  getExport(idEvent: number): __Observable<any> {
    return this.getExportResponse(idEvent).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
* EXPORT DASHBOARD
* @param idEvent
* @returns blob file
*/
  getExportBookForSaleResponse(idEvent: number): __Observable<__StrictHttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (idEvent != null) __params = __params.set('idEvent', idEvent.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + DashboardService.exportBookForSalePath(idEvent),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }

  getExportBookForSale(idEvent: number): __Observable<any> {
    return this.getExportBookForSaleResponse(idEvent).pipe(
      __map(_r => _r.body as any)
    );
  }

  /**
   *
   * @returns role
   */
  getRoleResponse(withMultipleRow?: boolean): __Observable<__StrictHttpResponse<any>> {
    let __params = this.newParams();
    if (withMultipleRow) {
      __params = __params.set('multipleRole', true);
    }
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + DashboardService.rolePath(),
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<any>;
      })
    );
  }

  getRole(withMultipleRow?: boolean): __Observable<any> {
    return this.getRoleResponse(withMultipleRow).pipe(
      __map(_r => _r.body as any)
    );
  }
}
